<template>
  <label
    :class="[
      'flex items-center justify-between p-3 rounded-xl border transition-all',
      type === 'radio' ? 'cursor-pointer' : '',
      isUnavailable
        ? 'border-gray-100 opacity-60 cursor-not-allowed bg-gray-50'
        : isSelected
        ? 'border-primary-600 bg-primary-50 ring-1 cursor-pointer'
        : isDisabled
        ? 'border-gray-100 opacity-50 cursor-not-allowed'
        : 'border-gray-200 hover:border-primary-300 hover:bg-gray-50 cursor-pointer'
    ]"
  >
    <div class="flex items-center gap-4">
      <div
        :class="[
          type === 'radio' ? 'w-6 h-6 rounded-full' : 'w-6 h-6 rounded-lg',
          'border flex items-center justify-center transition-colors',
          isSelected
            ? 'border-primary-600 bg-primary-600 text-white'
            : 'border-gray-300 bg-white'
        ]"
      >
        <Check v-if="isSelected" :size="14" style="stroke-width: 3;" />
      </div>
      <span
        :class="[
          'text-lg font-medium',
          isUnavailable
            ? 'text-gray-400'
            : isSelected
            ? 'text-primary-900'
            : 'text-gray-700'
        ]"
      >
        {{ modifier.name }}
        <span
          v-if="isUnavailable"
          class="ml-2 text-xs uppercase bg-gray-200 text-gray-600 px-2 py-0.5 rounded-full"
        >
          Unavailable
        </span>
      </span>
    </div>
    <span v-if="modifier.price > 0" class="text-gray-600 text-base font-medium">
      {{ formatPrice(modifier.price) }}
    </span>
    <input
      :type="type"
      class="hidden"
      :checked="isSelected"
      :disabled="isDisabled || isUnavailable"
      @change="handleChange"
    />
  </label>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ModifierOption",
  props: {
    modifier: {
      type: Object,
      required: true
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    currency: {
      type: String,
      default: "$"
    },
    type: {
      type: String,
      default: "checkbox",
      validator: (value) => ["radio", "checkbox"].includes(value)
    }
  },
  computed: {
    ...mapGetters(["formatPrice"]),
    isUnavailable() {
      return !!(this.modifier?.is_86d || this.modifier?.is86d);
    }
  },
  methods: {
    handleChange() {
      if (this.isDisabled || this.isUnavailable) return;
      this.$emit("select");
    }
  }
};
</script>
